import PropTypes from "prop-types";
import {Container,Table} from "react-bootstrap";
import React, {useMemo} from "react";
import IconField from "../elements/Formik/IconField.jsx";
import {Form, Formik} from "formik";
import SubmitButton from "../elements/Form/SubmitButton.jsx";
import AutoPersistToken from "../elements/Formik/AutoPersistToken.jsx";
import {format} from "date-fns";

const IssueInstallmentDueAnnexWidget = ({
      onSubmit,
  }) => {
    const formName = 'issueInstallmentDueAnnexForm';

    const todayFormatted = useMemo(() => format(new Date(), 'yyyy-MM-dd'), []);

    return (
            <Formik
                initialValues={{
                    dueDate: todayFormatted,
                    beginDate: '',
                    endDate: '',
                    premiumAmount: 0,
                    taxAmount: 0,
                    stickerAmount: 0,
                    guaranteeFundAmount: 0,
                }}
                validate={values => {
                    const errors = {};
                    if (values.premiumAmount === 0) {
                        errors.premiumAmount = 'Моля, въведете сумите по анекса!';
                    }

                    return errors;
                }}
                onSubmit={values => onSubmit({
                    ...values})}>
                {({isSubmitting, values}) => (
                    <Container as={Form} fluid className="gx-0">
                        <div className="table-responsive">
                            <Table striped className="mb-0">
                                <thead>
                                <tr>
                                    <th>Падеж</th>
                                    <th colSpan={2}>Покритие</th>
                                    <th>Премия</th>
                                    <th>Данък</th>
                                    <th>Стикер</th>
                                    <th>ГФ/ОФ</th>
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><IconField type="date" name="dueDate"
                                                   disabled={isSubmitting} />
                                    </td>
                                    <td>
                                        <IconField type="date" name="beginDate"
                                                   disabled={isSubmitting} />
                                        </td>
                                    <td>
                                        <IconField type="date" name="endDate"
                                                   disabled={isSubmitting} />
                                    </td>
                                    <td>
                                        <IconField type="number" name="premiumAmount" inputMode="decimal"
                                                   disabled={isSubmitting} maxLength={10} autoComplete="off"/>
                                    </td>
                                    <td>
                                        <IconField type="number" name="taxAmount" inputMode="decimal"
                                                   disabled={isSubmitting} maxLength={10} autoComplete="off"/>
                                    </td>
                                    <td>
                                        <IconField type="number" name="stickerAmount" inputMode="decimal"
                                                   disabled={isSubmitting} maxLength={10} autoComplete="off"/>
                                    </td>
                                    <td>
                                        <IconField type="number" name="guaranteeFundAmount" inputMode="decimal"
                                                   disabled={isSubmitting} maxLength={10} autoComplete="off"/>
                                    </td>
                                    <td><SubmitButton>Запиши</SubmitButton></td>
                                </tr>
                                </tbody>
                            </Table>
                        </div>
                        <AutoPersistToken formName={formName}/>
                    </Container>
                )}
            </Formik>
    );
}
IssueInstallmentDueAnnexWidget.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default IssueInstallmentDueAnnexWidget;